import { render, staticRenderFns } from "./SOCScreen5.vue?vue&type=template&id=24dad246&"
import script from "./SOCScreen5.vue?vue&type=script&lang=js&"
export * from "./SOCScreen5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports